export * from '@primeuix/themes/nora/chip';
export { default } from '@primeuix/themes/nora/chip';
